<ng-template #setLocationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Set Location</h4>
    <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="search-location-block">
      <app-google-location-search #picker [isEdit]="true"></app-google-location-search>
      <app-button class="d-flex justify-content-center mt-3" [btnCss]="'btn btn-primary'" [btnTitle]="'Select on Map'" [btnText]="'Select on Map'"
                  [isDisable]="!picker.selectedLocation || !picker.mapsReady"
                  (onBtnClick)="confirmSelection(picker.selectedLocation, modal)"></app-button>
    </div>
  </div>
</ng-template>
<app-confirm-location #confirmLocationModal (confirmed)="locationEmit.emit($event)"></app-confirm-location>
